var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolfunW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 68,
    viewBox: "0 0 151 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1",
    d: "M96.676 64.534a15.717 15.717 0 1 1 15.717-15.717 15.735 15.735 0 0 1-15.717 15.717m0-22.823a7.105 7.105 0 1 0 7.105 7.105 7.114 7.114 0 0 0-7.105-7.105",
    transform: "translate(-46.16 -19.043)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2",
    d: "M32.12 48.817a15.717 15.717 0 1 0-16.4 15.7v.017a7.105 7.105 0 1 1-7.108 7.106H0a15.717 15.717 0 1 0 26.844-11.089 15.68 15.68 0 0 0 5.276-11.734m-22.822 0a7.105 7.105 0 1 1 7.102 7.106 7.114 7.114 0 0 1-7.1-7.106",
    transform: "translate(0 -19.357)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 11",
    transform: "translate(69.93 10.793)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h8.612v34.457H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 3",
    d: "M263.707 32.468a15.735 15.735 0 0 0-15.717 15.717 7.105 7.105 0 1 1-14.211 0h-8.612a15.717 15.717 0 0 0 31.434 0 7.105 7.105 0 0 1 14.211 0V63.9h8.612V48.185a15.735 15.735 0 0 0-15.717-15.717",
    transform: "translate(-128.424 -18.68)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 12",
    transform: "translate(107.264 16.25)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.972v6.179H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13",
    transform: "translate(112.963 16.25)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.972v6.179H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 4",
    d: "M207.924 8.612V0c-8.666 0-15.093 7.051-15.093 15.717 0 .115 0 .23.007.345v29.352h8.612V24.329h6.474v-8.612h-6.481c0-3.918 2.563-7.105 6.481-7.105",
    transform: "translate(-109.929)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfunW);
export default __webpack_public_path__ + "static/media/golfun_w.ea999c7b0a55a10540c6a556e45120fd.svg";
export { ForwardRef as ReactComponent };